module.exports = __webpack_public_path__ + "img/Hetairoi64_ua.f6ad8541.webp";